module.exports = __webpack_public_path__ + "img/banner.5b9b4a04.png";